import React from 'react';
import Header from '../components/layout/Header';
import Merchandise from '../components/sections/Merchandise';
import Footer from '../components/layout/Footer';

const MerchandisePage = () => {
  return (
    <>
      <Header />
      <Merchandise />
      <Footer />
    </>
  );
};

export default MerchandisePage;
